import { useTranslation } from '@/translations/i18n'

export interface TooltipStat {
	label: string
	value: number | string
}

interface TooltipStatsProps {
	ngbhdsstats?: TooltipStat[]
	subgeoStats?: TooltipStat[]
}

export const TooltipStats = ({
	ngbhdsstats,
	subgeoStats
}: TooltipStatsProps) => {
	const { t } = useTranslation()
	if (
		(!ngbhdsstats || ngbhdsstats.length === 0) &&
		(!subgeoStats || subgeoStats.length === 0)
	) {
		return null
	}

	return (
		<div className='grid w-full grid-cols-[1fr_0.5fr_0.5fr] items-center justify-between gap-4 rounded-lg bg-neutral-100 p-2'>
			<div className='flex flex-col items-start gap-1'>
				<span className='overflow-wrap-break-word mb-1 max-w-full break-words text-neutral-600 text-xs [&_small]:ml-1 [&_small]:whitespace-nowrap [&_small]:text-[10px] [&_small]:text-neutral-500'>
					{t('subgeo:stat_gbv')}
				</span>
				<span className='overflow-wrap-break-word mb-1 max-w-full break-words text-neutral-600 text-xs [&_small]:ml-1 [&_small]:whitespace-nowrap [&_small]:text-[10px] [&_small]:text-neutral-500'>
					{t('subgeo:stat_occupancy')}
				</span>
				<span className='overflow-wrap-break-word mb-1 max-w-full break-words text-neutral-600 text-xs [&_small]:ml-1 [&_small]:whitespace-nowrap [&_small]:text-[10px] [&_small]:text-neutral-500'>
					{t('subgeo:stat_nights_stay')}
				</span>
			</div>
			<div className='flex flex-col items-end gap-1'>
				{ngbhdsstats?.map((stat) => (
					<span
						className='max-w-full break-words font-semibold text-neutral-900 text-sm'
						key={stat.value}
					>
						{stat.value}
					</span>
				))}
			</div>
			<div className='flex flex-col items-end gap-1'>
				{subgeoStats?.map((stat) => (
					<span
						className='max-w-full break-words font-semibold text-neutral-900 text-sm'
						key={stat.value}
					>
						{stat.value}
					</span>
				))}
			</div>
		</div>
	)
}
